import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'
import { TextField, ModelAutocompleteField, MenuSelectorField } from '@front/squirtle'

const SearchForm = ({ companyAutocompleteMutator, contractAutocompleteMutator, serviceAutocompleteMutator, getStatusOptionProps }) =>
  <Grid container justifyContent={'center'}>
    <Grid size={12}>
      <Box sx={{ borderRadius: 1, boxShadow: 6, p: 1 }}>
        <Grid container rowSpacing={3} spacing={1} justifyContent={'center'}>
          <Grid size={12}>
            <Typography variant={'h5'} sx={{ textAlign: 'center' }}> {I18n.t('voucher.search')} </Typography>
          </Grid>
          <Grid size="grow">
            <TextField name='code' label={I18n.t('voucher.code')} />
          </Grid>
          <Grid size="grow">
            <ModelAutocompleteField
              name='companyservice.contract.company'
              label={I18n.t('company.label', { count: 1 })}
              model_name='company'
              searchMode='search'
              autocompleteMutator={companyAutocompleteMutator}
              labelKeys={['name']}
              clearOnEmpty
            />
          </Grid>
          <Grid size="grow">
            <ModelAutocompleteField
              name='companyservice.contract'
              label={I18n.t('contract.label', { count: 1 })}
              model_name='companycontract'
              searchMode='search'
              autocompleteMutator={contractAutocompleteMutator}
              labelKeys={['client_id']}
              clearOnEmpty
            />
          </Grid>
          <Grid size="grow">
            <ModelAutocompleteField
              name='companyservice'
              label={I18n.t('companyservice.label', { count: 1 })}
              model_name='companyservice'
              searchMode='search'
              autocompleteMutator={serviceAutocompleteMutator}
              labelKeys={['client_id']}
              clearOnEmpty
            />
          </Grid>
          <Grid size="grow">
            <MenuSelectorField
              name='active'
              label={I18n.t('status.label', { count: 1 })}
              options={[
                { label: I18n.t('status.active'), value: true },
                { label: I18n.t('status.inactive'), value: false },
              ]}
              getOptionProps={getStatusOptionProps}
              clearOnEmpty
              allowNone={false}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  </Grid>

export default React.memo(SearchForm)
